/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchProgramAttendeeOperation,
    BatchProgramAttendeeOperationFromJSON,
    BatchProgramAttendeeOperationToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FeedbackRating,
    FeedbackRatingFromJSON,
    FeedbackRatingToJSON,
    FileAccess,
    FileAccessFromJSON,
    FileAccessToJSON,
    FilePurpose,
    FilePurposeFromJSON,
    FilePurposeToJSON,
    Gender,
    GenderFromJSON,
    GenderToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    HealthCardResponse,
    HealthCardResponseFromJSON,
    HealthCardResponseToJSON,
    MappedField,
    MappedFieldFromJSON,
    MappedFieldToJSON,
    ProgramAttendee,
    ProgramAttendeeFromJSON,
    ProgramAttendeeToJSON,
    ProgramAttendeeCreateParams,
    ProgramAttendeeCreateParamsFromJSON,
    ProgramAttendeeCreateParamsToJSON,
    ProgramAttendeeList,
    ProgramAttendeeListFromJSON,
    ProgramAttendeeListToJSON,
    ProgramAttendeeMergeParams,
    ProgramAttendeeMergeParamsFromJSON,
    ProgramAttendeeMergeParamsToJSON,
    ProgramAttendeeSuggestionList,
    ProgramAttendeeSuggestionListFromJSON,
    ProgramAttendeeSuggestionListToJSON,
    ProgramAttendeeUpdateParams,
    ProgramAttendeeUpdateParamsFromJSON,
    ProgramAttendeeUpdateParamsToJSON,
    ProgramEventType,
    ProgramEventTypeFromJSON,
    ProgramEventTypeToJSON,
    PropertyList,
    PropertyListFromJSON,
    PropertyListToJSON,
    RegistrationList,
    RegistrationListFromJSON,
    RegistrationListToJSON,
    RegistrationStatus,
    RegistrationStatusFromJSON,
    RegistrationStatusToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
} from '../models';

export interface CreateBulkProgramAttendeeRequest {
    program_id: string;
    ProgramAttendeeCreateParams: Array<ProgramAttendeeCreateParams>;
}

export interface CreateProgramAttendeeRequest {
    program_id: string;
    ProgramAttendeeCreateParams: ProgramAttendeeCreateParams;
}

export interface DisconnectProgramAttendeeRequest {
    program_id: string;
    program_attendee_id: string;
}

export interface FindAttendeeRegistrationsRequest {
    program_id: string;
    program_attendee_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    status?: Array<RegistrationStatus>;
    event_type?: Array<ProgramEventType>;
}

export interface FindHealthCardNumberProgramAttendeeRequest {
    program_id: string;
    program_attendee_id: string;
}

export interface FindOneProgramAttendeeRequest {
    program_id: string;
    program_attendee_id: string;
}

export interface FindProgramAttendeeMergeSuggestionsRequest {
    program_id: string;
    suggestion_type: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    age?: number;
    contact_id?: string;
    has_account?: boolean;
    gender?: Array<Gender>;
    membership_package_id?: Array<string>;
    is_archived?: boolean;
    age_lt?: number;
    age_gt?: number;
    age_lte?: number;
    age_gte?: number;
    date_of_birth_lt?: Date;
    date_of_birth_gt?: Date;
    date_of_birth_lte?: Date;
    date_of_birth_gte?: Date;
    birthday_lt?: Date;
    birthday_gt?: Date;
    birthday_lte?: Date;
    birthday_gte?: Date;
    feedback_rating?: Array<FeedbackRating>;
    num_registrations_lt?: number;
    num_registrations_gt?: number;
    num_registrations_lte?: number;
    num_registrations_gte?: number;
    first_attended_lt?: Date;
    first_attended_gt?: Date;
    first_attended_lte?: Date;
    first_attended_gte?: Date;
    last_attended_lt?: Date;
    last_attended_gt?: Date;
    last_attended_lte?: Date;
    last_attended_gte?: Date;
    last_registered_lt?: Date;
    last_registered_gt?: Date;
    last_registered_lte?: Date;
    last_registered_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface FindProgramAttendeesRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    age?: number;
    contact_id?: string;
    has_account?: boolean;
    gender?: Array<Gender>;
    membership_package_id?: Array<string>;
    is_archived?: boolean;
    age_lt?: number;
    age_gt?: number;
    age_lte?: number;
    age_gte?: number;
    date_of_birth_lt?: Date;
    date_of_birth_gt?: Date;
    date_of_birth_lte?: Date;
    date_of_birth_gte?: Date;
    birthday_lt?: Date;
    birthday_gt?: Date;
    birthday_lte?: Date;
    birthday_gte?: Date;
    feedback_rating?: Array<FeedbackRating>;
    num_registrations_lt?: number;
    num_registrations_gt?: number;
    num_registrations_lte?: number;
    num_registrations_gte?: number;
    first_attended_lt?: Date;
    first_attended_gt?: Date;
    first_attended_lte?: Date;
    first_attended_gte?: Date;
    last_attended_lt?: Date;
    last_attended_gt?: Date;
    last_attended_lte?: Date;
    last_attended_gte?: Date;
    last_registered_lt?: Date;
    last_registered_gt?: Date;
    last_registered_lte?: Date;
    last_registered_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface GetPropertiesProgramAttendeeRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
}

export interface GetPropertyValuesProgramAttendeeRequest {
    program_id: string;
    property_key: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
}

export interface MergeAttendeeProgramAttendeeRequest {
    program_id: string;
    program_attendee_id: string;
    ProgramAttendeeMergeParams: ProgramAttendeeMergeParams;
}

export interface ParseFileProgramAttendeeRequest {
    program_id: string;
    purpose: FilePurpose;
    file: Blob;
    access?: FileAccess;
}

export interface UpdateProgramAttendeeRequest {
    program_id: string;
    program_attendee_id: string;
    ProgramAttendeeUpdateParams: ProgramAttendeeUpdateParams;
}

/**
 * 
 */
export class AttendeesApi extends runtime.BaseAPI {

    /**
     * Create program attendees in bulk
     */
    async createBulkProgramAttendeeRaw(requestParameters: CreateBulkProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchProgramAttendeeOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createBulkProgramAttendee.');
        }

        if (requestParameters.ProgramAttendeeCreateParams === null || requestParameters.ProgramAttendeeCreateParams === undefined) {
            throw new runtime.RequiredError('ProgramAttendeeCreateParams','Required parameter requestParameters.ProgramAttendeeCreateParams was null or undefined when calling createBulkProgramAttendee.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/attendees/bulk`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.ProgramAttendeeCreateParams.map(ProgramAttendeeCreateParamsToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchProgramAttendeeOperationFromJSON(jsonValue));
    }

    /**
     * Create program attendees in bulk
     */
    async createBulkProgramAttendee(requestParameters: CreateBulkProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchProgramAttendeeOperation> {
        const response = await this.createBulkProgramAttendeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create connected attendee
     */
    async createProgramAttendeeRaw(requestParameters: CreateProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramAttendee>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createProgramAttendee.');
        }

        if (requestParameters.ProgramAttendeeCreateParams === null || requestParameters.ProgramAttendeeCreateParams === undefined) {
            throw new runtime.RequiredError('ProgramAttendeeCreateParams','Required parameter requestParameters.ProgramAttendeeCreateParams was null or undefined when calling createProgramAttendee.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/attendees`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProgramAttendeeCreateParamsToJSON(requestParameters.ProgramAttendeeCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramAttendeeFromJSON(jsonValue));
    }

    /**
     * Create connected attendee
     */
    async createProgramAttendee(requestParameters: CreateProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramAttendee> {
        const response = await this.createProgramAttendeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Disconnect connected attendee
     */
    async disconnectProgramAttendeeRaw(requestParameters: DisconnectProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling disconnectProgramAttendee.');
        }

        if (requestParameters.program_attendee_id === null || requestParameters.program_attendee_id === undefined) {
            throw new runtime.RequiredError('program_attendee_id','Required parameter requestParameters.program_attendee_id was null or undefined when calling disconnectProgramAttendee.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/attendees/{program_attendee_id}/disconnect`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"program_attendee_id"}}`, encodeURIComponent(String(requestParameters.program_attendee_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Disconnect connected attendee
     */
    async disconnectProgramAttendee(requestParameters: DisconnectProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.disconnectProgramAttendeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all registrations
     */
    async findAttendeeRegistrationsRaw(requestParameters: FindAttendeeRegistrationsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RegistrationList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findAttendeeRegistrations.');
        }

        if (requestParameters.program_attendee_id === null || requestParameters.program_attendee_id === undefined) {
            throw new runtime.RequiredError('program_attendee_id','Required parameter requestParameters.program_attendee_id was null or undefined when calling findAttendeeRegistrations.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.event_type) {
            queryParameters['event_type'] = requestParameters.event_type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/attendees/{program_attendee_id}/registrations`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"program_attendee_id"}}`, encodeURIComponent(String(requestParameters.program_attendee_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationListFromJSON(jsonValue));
    }

    /**
     * List all registrations
     */
    async findAttendeeRegistrations(requestParameters: FindAttendeeRegistrationsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RegistrationList> {
        const response = await this.findAttendeeRegistrationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find health card number for attendee by id
     */
    async findHealthCardNumberProgramAttendeeRaw(requestParameters: FindHealthCardNumberProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<HealthCardResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findHealthCardNumberProgramAttendee.');
        }

        if (requestParameters.program_attendee_id === null || requestParameters.program_attendee_id === undefined) {
            throw new runtime.RequiredError('program_attendee_id','Required parameter requestParameters.program_attendee_id was null or undefined when calling findHealthCardNumberProgramAttendee.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/attendees/{program_attendee_id}/health_card_number`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"program_attendee_id"}}`, encodeURIComponent(String(requestParameters.program_attendee_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthCardResponseFromJSON(jsonValue));
    }

    /**
     * Find health card number for attendee by id
     */
    async findHealthCardNumberProgramAttendee(requestParameters: FindHealthCardNumberProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<HealthCardResponse> {
        const response = await this.findHealthCardNumberProgramAttendeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find connected attendee by id
     */
    async findOneProgramAttendeeRaw(requestParameters: FindOneProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramAttendee>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneProgramAttendee.');
        }

        if (requestParameters.program_attendee_id === null || requestParameters.program_attendee_id === undefined) {
            throw new runtime.RequiredError('program_attendee_id','Required parameter requestParameters.program_attendee_id was null or undefined when calling findOneProgramAttendee.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/attendees/{program_attendee_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"program_attendee_id"}}`, encodeURIComponent(String(requestParameters.program_attendee_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramAttendeeFromJSON(jsonValue));
    }

    /**
     * Find connected attendee by id
     */
    async findOneProgramAttendee(requestParameters: FindOneProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramAttendee> {
        const response = await this.findOneProgramAttendeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all attendee suggestions
     */
    async findProgramAttendeeMergeSuggestionsRaw(requestParameters: FindProgramAttendeeMergeSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramAttendeeSuggestionList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findProgramAttendeeMergeSuggestions.');
        }

        if (requestParameters.suggestion_type === null || requestParameters.suggestion_type === undefined) {
            throw new runtime.RequiredError('suggestion_type','Required parameter requestParameters.suggestion_type was null or undefined when calling findProgramAttendeeMergeSuggestions.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.age !== undefined) {
            queryParameters['age'] = requestParameters.age;
        }

        if (requestParameters.contact_id !== undefined) {
            queryParameters['contact_id'] = requestParameters.contact_id;
        }

        if (requestParameters.has_account !== undefined) {
            queryParameters['has_account'] = requestParameters.has_account;
        }

        if (requestParameters.gender) {
            queryParameters['gender'] = requestParameters.gender;
        }

        if (requestParameters.membership_package_id) {
            queryParameters['membership_package_id'] = requestParameters.membership_package_id;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        if (requestParameters.age_lt !== undefined) {
            queryParameters['age_lt'] = requestParameters.age_lt;
        }

        if (requestParameters.age_gt !== undefined) {
            queryParameters['age_gt'] = requestParameters.age_gt;
        }

        if (requestParameters.age_lte !== undefined) {
            queryParameters['age_lte'] = requestParameters.age_lte;
        }

        if (requestParameters.age_gte !== undefined) {
            queryParameters['age_gte'] = requestParameters.age_gte;
        }

        if (requestParameters.date_of_birth_lt !== undefined) {
            queryParameters['date_of_birth_lt'] = (requestParameters.date_of_birth_lt as any).toISOString();
        }

        if (requestParameters.date_of_birth_gt !== undefined) {
            queryParameters['date_of_birth_gt'] = (requestParameters.date_of_birth_gt as any).toISOString();
        }

        if (requestParameters.date_of_birth_lte !== undefined) {
            queryParameters['date_of_birth_lte'] = (requestParameters.date_of_birth_lte as any).toISOString();
        }

        if (requestParameters.date_of_birth_gte !== undefined) {
            queryParameters['date_of_birth_gte'] = (requestParameters.date_of_birth_gte as any).toISOString();
        }

        if (requestParameters.birthday_lt !== undefined) {
            queryParameters['birthday_lt'] = (requestParameters.birthday_lt as any).toISOString();
        }

        if (requestParameters.birthday_gt !== undefined) {
            queryParameters['birthday_gt'] = (requestParameters.birthday_gt as any).toISOString();
        }

        if (requestParameters.birthday_lte !== undefined) {
            queryParameters['birthday_lte'] = (requestParameters.birthday_lte as any).toISOString();
        }

        if (requestParameters.birthday_gte !== undefined) {
            queryParameters['birthday_gte'] = (requestParameters.birthday_gte as any).toISOString();
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.num_registrations_lt !== undefined) {
            queryParameters['num_registrations_lt'] = requestParameters.num_registrations_lt;
        }

        if (requestParameters.num_registrations_gt !== undefined) {
            queryParameters['num_registrations_gt'] = requestParameters.num_registrations_gt;
        }

        if (requestParameters.num_registrations_lte !== undefined) {
            queryParameters['num_registrations_lte'] = requestParameters.num_registrations_lte;
        }

        if (requestParameters.num_registrations_gte !== undefined) {
            queryParameters['num_registrations_gte'] = requestParameters.num_registrations_gte;
        }

        if (requestParameters.first_attended_lt !== undefined) {
            queryParameters['first_attended_lt'] = (requestParameters.first_attended_lt as any).toISOString();
        }

        if (requestParameters.first_attended_gt !== undefined) {
            queryParameters['first_attended_gt'] = (requestParameters.first_attended_gt as any).toISOString();
        }

        if (requestParameters.first_attended_lte !== undefined) {
            queryParameters['first_attended_lte'] = (requestParameters.first_attended_lte as any).toISOString();
        }

        if (requestParameters.first_attended_gte !== undefined) {
            queryParameters['first_attended_gte'] = (requestParameters.first_attended_gte as any).toISOString();
        }

        if (requestParameters.last_attended_lt !== undefined) {
            queryParameters['last_attended_lt'] = (requestParameters.last_attended_lt as any).toISOString();
        }

        if (requestParameters.last_attended_gt !== undefined) {
            queryParameters['last_attended_gt'] = (requestParameters.last_attended_gt as any).toISOString();
        }

        if (requestParameters.last_attended_lte !== undefined) {
            queryParameters['last_attended_lte'] = (requestParameters.last_attended_lte as any).toISOString();
        }

        if (requestParameters.last_attended_gte !== undefined) {
            queryParameters['last_attended_gte'] = (requestParameters.last_attended_gte as any).toISOString();
        }

        if (requestParameters.last_registered_lt !== undefined) {
            queryParameters['last_registered_lt'] = (requestParameters.last_registered_lt as any).toISOString();
        }

        if (requestParameters.last_registered_gt !== undefined) {
            queryParameters['last_registered_gt'] = (requestParameters.last_registered_gt as any).toISOString();
        }

        if (requestParameters.last_registered_lte !== undefined) {
            queryParameters['last_registered_lte'] = (requestParameters.last_registered_lte as any).toISOString();
        }

        if (requestParameters.last_registered_gte !== undefined) {
            queryParameters['last_registered_gte'] = (requestParameters.last_registered_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/attendee_suggestions/{suggestion_type}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"suggestion_type"}}`, encodeURIComponent(String(requestParameters.suggestion_type))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramAttendeeSuggestionListFromJSON(jsonValue));
    }

    /**
     * List all attendee suggestions
     */
    async findProgramAttendeeMergeSuggestions(requestParameters: FindProgramAttendeeMergeSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramAttendeeSuggestionList> {
        const response = await this.findProgramAttendeeMergeSuggestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all connected attendees
     */
    async findProgramAttendeesRaw(requestParameters: FindProgramAttendeesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramAttendeeList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findProgramAttendees.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.age !== undefined) {
            queryParameters['age'] = requestParameters.age;
        }

        if (requestParameters.contact_id !== undefined) {
            queryParameters['contact_id'] = requestParameters.contact_id;
        }

        if (requestParameters.has_account !== undefined) {
            queryParameters['has_account'] = requestParameters.has_account;
        }

        if (requestParameters.gender) {
            queryParameters['gender'] = requestParameters.gender;
        }

        if (requestParameters.membership_package_id) {
            queryParameters['membership_package_id'] = requestParameters.membership_package_id;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        if (requestParameters.age_lt !== undefined) {
            queryParameters['age_lt'] = requestParameters.age_lt;
        }

        if (requestParameters.age_gt !== undefined) {
            queryParameters['age_gt'] = requestParameters.age_gt;
        }

        if (requestParameters.age_lte !== undefined) {
            queryParameters['age_lte'] = requestParameters.age_lte;
        }

        if (requestParameters.age_gte !== undefined) {
            queryParameters['age_gte'] = requestParameters.age_gte;
        }

        if (requestParameters.date_of_birth_lt !== undefined) {
            queryParameters['date_of_birth_lt'] = (requestParameters.date_of_birth_lt as any).toISOString();
        }

        if (requestParameters.date_of_birth_gt !== undefined) {
            queryParameters['date_of_birth_gt'] = (requestParameters.date_of_birth_gt as any).toISOString();
        }

        if (requestParameters.date_of_birth_lte !== undefined) {
            queryParameters['date_of_birth_lte'] = (requestParameters.date_of_birth_lte as any).toISOString();
        }

        if (requestParameters.date_of_birth_gte !== undefined) {
            queryParameters['date_of_birth_gte'] = (requestParameters.date_of_birth_gte as any).toISOString();
        }

        if (requestParameters.birthday_lt !== undefined) {
            queryParameters['birthday_lt'] = (requestParameters.birthday_lt as any).toISOString();
        }

        if (requestParameters.birthday_gt !== undefined) {
            queryParameters['birthday_gt'] = (requestParameters.birthday_gt as any).toISOString();
        }

        if (requestParameters.birthday_lte !== undefined) {
            queryParameters['birthday_lte'] = (requestParameters.birthday_lte as any).toISOString();
        }

        if (requestParameters.birthday_gte !== undefined) {
            queryParameters['birthday_gte'] = (requestParameters.birthday_gte as any).toISOString();
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.num_registrations_lt !== undefined) {
            queryParameters['num_registrations_lt'] = requestParameters.num_registrations_lt;
        }

        if (requestParameters.num_registrations_gt !== undefined) {
            queryParameters['num_registrations_gt'] = requestParameters.num_registrations_gt;
        }

        if (requestParameters.num_registrations_lte !== undefined) {
            queryParameters['num_registrations_lte'] = requestParameters.num_registrations_lte;
        }

        if (requestParameters.num_registrations_gte !== undefined) {
            queryParameters['num_registrations_gte'] = requestParameters.num_registrations_gte;
        }

        if (requestParameters.first_attended_lt !== undefined) {
            queryParameters['first_attended_lt'] = (requestParameters.first_attended_lt as any).toISOString();
        }

        if (requestParameters.first_attended_gt !== undefined) {
            queryParameters['first_attended_gt'] = (requestParameters.first_attended_gt as any).toISOString();
        }

        if (requestParameters.first_attended_lte !== undefined) {
            queryParameters['first_attended_lte'] = (requestParameters.first_attended_lte as any).toISOString();
        }

        if (requestParameters.first_attended_gte !== undefined) {
            queryParameters['first_attended_gte'] = (requestParameters.first_attended_gte as any).toISOString();
        }

        if (requestParameters.last_attended_lt !== undefined) {
            queryParameters['last_attended_lt'] = (requestParameters.last_attended_lt as any).toISOString();
        }

        if (requestParameters.last_attended_gt !== undefined) {
            queryParameters['last_attended_gt'] = (requestParameters.last_attended_gt as any).toISOString();
        }

        if (requestParameters.last_attended_lte !== undefined) {
            queryParameters['last_attended_lte'] = (requestParameters.last_attended_lte as any).toISOString();
        }

        if (requestParameters.last_attended_gte !== undefined) {
            queryParameters['last_attended_gte'] = (requestParameters.last_attended_gte as any).toISOString();
        }

        if (requestParameters.last_registered_lt !== undefined) {
            queryParameters['last_registered_lt'] = (requestParameters.last_registered_lt as any).toISOString();
        }

        if (requestParameters.last_registered_gt !== undefined) {
            queryParameters['last_registered_gt'] = (requestParameters.last_registered_gt as any).toISOString();
        }

        if (requestParameters.last_registered_lte !== undefined) {
            queryParameters['last_registered_lte'] = (requestParameters.last_registered_lte as any).toISOString();
        }

        if (requestParameters.last_registered_gte !== undefined) {
            queryParameters['last_registered_gte'] = (requestParameters.last_registered_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/attendees`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramAttendeeListFromJSON(jsonValue));
    }

    /**
     * List all connected attendees
     */
    async findProgramAttendees(requestParameters: FindProgramAttendeesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramAttendeeList> {
        const response = await this.findProgramAttendeesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all attendee properties
     */
    async getPropertiesProgramAttendeeRaw(requestParameters: GetPropertiesProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PropertyList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling getPropertiesProgramAttendee.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/attendees/properties`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PropertyListFromJSON(jsonValue));
    }

    /**
     * List all attendee properties
     */
    async getPropertiesProgramAttendee(requestParameters: GetPropertiesProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PropertyList> {
        const response = await this.getPropertiesProgramAttendeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find attendee property values by key
     */
    async getPropertyValuesProgramAttendeeRaw(requestParameters: GetPropertyValuesProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PropertyList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling getPropertyValuesProgramAttendee.');
        }

        if (requestParameters.property_key === null || requestParameters.property_key === undefined) {
            throw new runtime.RequiredError('property_key','Required parameter requestParameters.property_key was null or undefined when calling getPropertyValuesProgramAttendee.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/attendees/properties/{property_key}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"property_key"}}`, encodeURIComponent(String(requestParameters.property_key))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PropertyListFromJSON(jsonValue));
    }

    /**
     * Find attendee property values by key
     */
    async getPropertyValuesProgramAttendee(requestParameters: GetPropertyValuesProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PropertyList> {
        const response = await this.getPropertyValuesProgramAttendeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Merge attendee
     */
    async mergeAttendeeProgramAttendeeRaw(requestParameters: MergeAttendeeProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramAttendee>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling mergeAttendeeProgramAttendee.');
        }

        if (requestParameters.program_attendee_id === null || requestParameters.program_attendee_id === undefined) {
            throw new runtime.RequiredError('program_attendee_id','Required parameter requestParameters.program_attendee_id was null or undefined when calling mergeAttendeeProgramAttendee.');
        }

        if (requestParameters.ProgramAttendeeMergeParams === null || requestParameters.ProgramAttendeeMergeParams === undefined) {
            throw new runtime.RequiredError('ProgramAttendeeMergeParams','Required parameter requestParameters.ProgramAttendeeMergeParams was null or undefined when calling mergeAttendeeProgramAttendee.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/attendees/{program_attendee_id}/merge`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"program_attendee_id"}}`, encodeURIComponent(String(requestParameters.program_attendee_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProgramAttendeeMergeParamsToJSON(requestParameters.ProgramAttendeeMergeParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramAttendeeFromJSON(jsonValue));
    }

    /**
     * Merge attendee
     */
    async mergeAttendeeProgramAttendee(requestParameters: MergeAttendeeProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramAttendee> {
        const response = await this.mergeAttendeeProgramAttendeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Parse csv/xlsx file and map to contact
     */
    async parseFileProgramAttendeeRaw(requestParameters: ParseFileProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Array<MappedField>>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling parseFileProgramAttendee.');
        }

        if (requestParameters.purpose === null || requestParameters.purpose === undefined) {
            throw new runtime.RequiredError('purpose','Required parameter requestParameters.purpose was null or undefined when calling parseFileProgramAttendee.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling parseFileProgramAttendee.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.purpose !== undefined) {
            formParams.append('purpose', new Blob([JSON.stringify(FilePurposeToJSON(requestParameters.purpose))], { type: "application/json", }));
                    }

        if (requestParameters.access !== undefined) {
            formParams.append('access', new Blob([JSON.stringify(FileAccessToJSON(requestParameters.access))], { type: "application/json", }));
                    }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/api/v1/programs/{program_id}/attendees/parse`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MappedFieldFromJSON));
    }

    /**
     * Parse csv/xlsx file and map to contact
     */
    async parseFileProgramAttendee(requestParameters: ParseFileProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Array<MappedField>> {
        const response = await this.parseFileProgramAttendeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update connected attendee
     */
    async updateProgramAttendeeRaw(requestParameters: UpdateProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramAttendee>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateProgramAttendee.');
        }

        if (requestParameters.program_attendee_id === null || requestParameters.program_attendee_id === undefined) {
            throw new runtime.RequiredError('program_attendee_id','Required parameter requestParameters.program_attendee_id was null or undefined when calling updateProgramAttendee.');
        }

        if (requestParameters.ProgramAttendeeUpdateParams === null || requestParameters.ProgramAttendeeUpdateParams === undefined) {
            throw new runtime.RequiredError('ProgramAttendeeUpdateParams','Required parameter requestParameters.ProgramAttendeeUpdateParams was null or undefined when calling updateProgramAttendee.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/attendees/{program_attendee_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"program_attendee_id"}}`, encodeURIComponent(String(requestParameters.program_attendee_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProgramAttendeeUpdateParamsToJSON(requestParameters.ProgramAttendeeUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramAttendeeFromJSON(jsonValue));
    }

    /**
     * Update connected attendee
     */
    async updateProgramAttendee(requestParameters: UpdateProgramAttendeeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramAttendee> {
        const response = await this.updateProgramAttendeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
